













































































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import api from '../../../api/v2/api'
import UserQuestion from '../../../api/v2/models/user_question'
import LessonRelative from '../../../api/v2/models/lesson_relative'
import CourseRelative from '../../../api/v2/models/course_relative'

@Component({
  components: {}
})
export default class UserQuestionSidebar extends Vue {
  tab: number = 0
  sideBarData: {
    sameLessonQuestions: UserQuestion[],
    sameCourseLessons: LessonRelative[],
    courses: CourseRelative[]
  } = {
    sameLessonQuestions: [],
    sameCourseLessons: [],
    courses: []
  }

  created() {
    this.loadData()
  }

  async loadData() {
    try {
      this.sideBarData = await api.userQuestion.relativeLists(this.$route.params.questionId)
    } catch(e) {
    } finally {
    }
  }

  @Watch('$route')
  changeRoute(val, oldVal) {
    this.loadData()
  }
}
